var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
// icons
import featuredTag from "@frameworks/shared-library/assets/images/features/Markets/Pms/focused.svg";
// stylesheet
import "@frameworks/shared-library/stylesheets/components/Offerings/Generic/OfferingsTable.scss";
// components
import EdButton, { EdButtonIcon, } from "@frameworks/web/components/generic/edbutton/edButton";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import OfferingsTableCheckboxActions from "@frameworks/shared-library/components//Offerings/Generic/OfferingsTableCheckboxActions/OfferingsTableCheckboxActions";
import config from "@frameworks/salesjourney/config/domain";
import DynamicPagination from "@frameworks/shared-library/components/Pagination/Pagination";
import GenericTableShimmer from "@frameworks/shared-library/components/GenericTableShimmer/GenericTableShimmer";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import GenericPopup from "@frameworks/shared-library/components/GenericPopup";
import OfferingsColumnFilters from "@frameworks/shared-library/components/Offerings/Generic/OfferingsColumnFilters/OfferingsColumnFilters";
import OfferingsRangeFilters from "@frameworks/shared-library/components/Offerings/Generic/GenericFilterSort/OfferingsRangeFilters/OfferingsRangeFilters";
import ShareSocialLinks from "@frameworks/shared-library/components/Generic/shareSocialLinks/shareSocialLinks";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import { FilterSortListBookMark, } from "../../../constants/constant";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import { ILoginTypeEnum } from "@domains/salesFeatures/Login/entities/iLogin";
export var defaultActiveColumnFilers = {
    currentActiveColumnFilter: "",
    filtersList: [],
};
var getSchemeValue = function (schemeValuesArr, schemeKeysArr, schemeKey) {
    var _a;
    return (_a = schemeValuesArr[schemeKeysArr.indexOf(schemeKey)]) !== null && _a !== void 0 ? _a : "";
};
var getTagDetails = {
    isNew: {
        text: "New",
        icon: React.createElement("i", { className: "icon edel-icon-glossy" }),
        className: "icon-text-container bg_frosted-aqua txt_ocean-whisper",
    },
    isfocused: {
        text: "Focused",
        icon: React.createElement("i", { className: "icon edel-icon-crown" }),
        className: "icon-text-container bg_candy-pink txt_dark-purple",
    },
};
var TopFundsTableDesk = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var _k = __read(useState([]), 2), checked = _k[0], setChecked = _k[1];
    var _l = __read(useState(false), 2), showShareModal = _l[0], setshowShareModal = _l[1];
    var _m = __read(useState(""), 2), orderBy = _m[0], setOrderBy = _m[1];
    var _o = __read(useState(null), 2), orderByDesc = _o[0], setOrderByDesc = _o[1];
    var _p = __read(useState(defaultActiveColumnFilers), 2), currentActiveColumnFilterConfig = _p[0], setCurrentActiveColumnFilterConfig = _p[1];
    var _q = __read(useState(), 2), sharelinks = _q[0], setSharelinks = _q[1];
    var partnerCategory = localStorage.getItem(ELocalStorageKeys.LoginType);
    var _r = useSelector(function (state) { return state.markets.AifPms; }), filterListFundName = _r.filterListFundName, filterListAIFFundName = _r.filterListAIFFundName;
    var tableRef = React.useRef(null);
    var _s = __read(useState(true), 2), firstTimePMS = _s[0], setFirstTimePMS = _s[1];
    var _t = __read(useState(true), 2), firstTimeAIF = _t[0], setFirstTimeAIF = _t[1];
    useEffect(function () {
        var sidebarDiv = document.querySelector(".collapsed-sidebar");
        if (showShareModal) {
            sidebarDiv === null || sidebarDiv === void 0 ? void 0 : sidebarDiv.classList.add("low-index");
        }
        return function () {
            sidebarDiv === null || sidebarDiv === void 0 ? void 0 : sidebarDiv.classList.remove("low-index");
        };
    }, [showShareModal]);
    var onSortToggleClick = function (item) {
        var filter = {
            orderByDesc: false,
            orderBy: "",
        };
        filter["orderBy"] = item.key3;
        filter["orderByDesc"] = !props.requestPayload.orderByDesc;
        props.setRequestPayload(__assign(__assign(__assign({}, props.requestPayload), { page: 1 }), filter));
    };
    var checkIfFilterIsAppliedForTableColumn = function (keyName) {
        var flag = false;
        if (props.requestPayload) {
            //@ts-ignore
            var valueInState = props.requestPayload[(keyName === "display_name"
                ? "fundNameList"
                : keyName)];
            if ((typeof valueInState === "string" ||
                typeof valueInState === "number") &&
                !!valueInState)
                flag = true;
            if (typeof valueInState === "object" &&
                !Array.isArray(valueInState) &&
                !!valueInState)
                flag = true;
            if (Array.isArray(valueInState) && valueInState.length)
                flag = true;
            return flag;
        }
    };
    var onDropDownChange = function (data, param) {
        var _a;
        props.setSummaryData(__assign(__assign({}, props.summaryData), { returnExpectation: __assign(__assign({}, (_a = props.summaryData) === null || _a === void 0 ? void 0 : _a.returnExpectation), { returnExpectation: {
                    label: data === null || data === void 0 ? void 0 : data.label,
                    value: data === null || data === void 0 ? void 0 : data.label, //data?.value === ">" ? "Above" : "Below",
                } }) }));
    };
    var onInputFormChange = function (name, value, param) {
        var _a;
        props.setSummaryData(__assign(__assign({}, props.summaryData), { returnExpectation: __assign(__assign({}, (_a = props.summaryData) === null || _a === void 0 ? void 0 : _a.returnExpectation), { conditionValue: value }) }));
    };
    var operator = (_d = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.summaryData) === null || _a === void 0 ? void 0 : _a.returnExpectation) === null || _b === void 0 ? void 0 : _b.returnExpectation) === null || _c === void 0 ? void 0 : _c.label) === null || _d === void 0 ? void 0 : _d.toString().toUpperCase();
    var validOperator = operator === "ABOVE" ? ">" : operator === "BELOW" ? "<" : "=";
    var generateColumnFilterPopupChildren = function (keyName, data) {
        var _a;
        var _b, _c;
        switch (keyName) {
            case "returns_expectations":
                return (React.createElement(OfferingsRangeFilters, { typeOfFilter: "returns_expectations", onDropDownChange: onDropDownChange, onInputFormChange: onInputFormChange, mutualFundFilterSortValues: (_a = {},
                        _a["returns_expectations"] = {
                            operator: validOperator,
                            value: (_c = (_b = props === null || props === void 0 ? void 0 : props.summaryData) === null || _b === void 0 ? void 0 : _b.returnExpectation) === null || _c === void 0 ? void 0 : _c.conditionValue,
                            label: operator,
                        },
                        _a) }));
            // case "display_name":
            //   return (
            //     <ScrollPagination
            //       totalPages={props.fundTotalPages}
            //       pageSize={10}
            //       fetchData={async (page: number, size: number) => {
            //         let response: any = {};
            //         if (props.fundTotalPages > 1) {
            //           response = await aifPmsDi.aifPms.getFilterDetails({
            //             category_code: String(props.categoryCode),
            //             fieldName: FieldNames.FUND_NAME,
            //             page,
            //             pageSize: size,
            //           });
            //           props.setFundTotalPages(response?.totalitems);
            //         }
            //         return props.fundTotalPages > 1
            //           ? response?.data?.map((item: any) => {
            //               return {
            //                 filter_value: item.name,
            //                 name: item.filterId,
            //               };
            //             })
            //           : dataFund;
            //       }}
            //       renderItem={(items: any) => {
            //         return (
            //           <GenerateCheckbox
            //             filtersData={items}
            //             selectedDataArr={props?.summaryData?.fundNameList}
            //             placeholder={""}
            //             keyName={FieldNames.FUND_NAME}
            //           />
            //         );
            //       }}
            //     />
            //   );
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    var handleUpdateCurrentActiveColumnFilter = function (keyName) {
        var localStateObj = {
            currentActiveColumnFilter: keyName,
            filtersList: [],
        };
        setCurrentActiveColumnFilterConfig(localStateObj);
    };
    var dataFund = (props === null || props === void 0 ? void 0 : props.categoryCode) === ESubProductIds.AIF
        ? (filterListAIFFundName === null || filterListAIFFundName === void 0 ? void 0 : filterListAIFFundName.map(function (item) {
            return {
                filter_value: item.name,
                name: item.filterId,
            };
        })) || []
        : filterListFundName === null || filterListFundName === void 0 ? void 0 : filterListFundName.map(function (item) {
            return {
                filter_value: item.name,
                name: item.filterId,
            };
        });
    var generateTableColumnName = function (name, keyName) {
        return (React.createElement("div", { id: keyName, className: "primary-column-filter-container d-flex align-items-center gap-2 ".concat((!!currentActiveColumnFilterConfig.currentActiveColumnFilter &&
                currentActiveColumnFilterConfig.currentActiveColumnFilter ===
                    keyName) ||
                checkIfFilterIsAppliedForTableColumn(keyName)
                ? "active-column-filter"
                : "") },
            props.requestPayload && (React.createElement(GenericPopup, { isShow: keyName ===
                    currentActiveColumnFilterConfig.currentActiveColumnFilter, setIsShow: function () {
                    handleUpdateCurrentActiveColumnFilter(keyName !==
                        currentActiveColumnFilterConfig.currentActiveColumnFilter
                        ? keyName
                        : "");
                }, children: React.createElement(OfferingsColumnFilters, { parentClassName: "checkboxes-filters save-product-bookmark", internalFilterChildren: generateColumnFilterPopupChildren(keyName, dataFund), customHeader: null, applyCallback: function () {
                        var _a, _b, _c, _d, _e;
                        handleUpdateCurrentActiveColumnFilter("");
                        props.handleApplyFilterCallback(__assign(__assign({}, props.summaryData), { returnExpectation: {
                                returnExpectation: (_b = (_a = props.summaryData) === null || _a === void 0 ? void 0 : _a.returnExpectation) === null || _b === void 0 ? void 0 : _b.returnExpectation,
                                conditionValue: (_d = (_c = props.summaryData) === null || _c === void 0 ? void 0 : _c.returnExpectation) === null || _d === void 0 ? void 0 : _d.conditionValue,
                            }, fundNameList: (_e = props === null || props === void 0 ? void 0 : props.summaryData) === null || _e === void 0 ? void 0 : _e.fundNameList }));
                    }, cancelCallback: function () {
                        handleUpdateCurrentActiveColumnFilter("");
                    }, clearAllCallback: function () {
                        var _a, _b;
                        handleUpdateCurrentActiveColumnFilter("");
                        var filteredFundNames = props.summaryData.fundNameList.filter(function (name) { return name !== "All"; });
                        if (keyName === "display_name") {
                            props === null || props === void 0 ? void 0 : props.handleRemoveThroughLabels("fundNameList", filteredFundNames);
                            props.setSummaryData(__assign(__assign({}, props.summaryData), { fundNameList: [] }));
                        }
                        if (keyName === "returns_expectations") {
                            props.setSummaryData(__assign(__assign({}, props.summaryData), { returnExpectation: {
                                    returnExpectation: (_b = (_a = props.summaryData) === null || _a === void 0 ? void 0 : _a.returnExpectation) === null || _b === void 0 ? void 0 : _b.returnExpectation,
                                    conditionValue: "",
                                } }));
                            props === null || props === void 0 ? void 0 : props.handleRemoveThroughLabels("returns_expectations", "");
                        }
                        checkIfFilterIsAppliedForTableColumn("");
                    } }), placement: "bottom-end", onClose: function () {
                    return setCurrentActiveColumnFilterConfig({
                        currentActiveColumnFilter: "",
                        filtersList: [],
                    });
                }, button: keyName === "returns_expectations" ? (React.createElement("span", { className: "column-filter-icon-container d-flex align-items-center justify-content-center hand_cursor" },
                    React.createElement("i", { className: "edel-icon-curved-filter" }))) : (React.createElement(React.Fragment, null)), parentClass: "offerings-dropdown-container border-0", buttonOnClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleUpdateCurrentActiveColumnFilter(keyName);
                }, isHeadline: true, removeTooltipArrow: true })),
            React.createElement("span", null, name || "-")));
    };
    var generateSchemeName = function (keys, keysForCustomFunction) {
        var tagDetails = {};
        var isFocusedScheme = getSchemeValue(keys, keysForCustomFunction, "isfocused");
        if (isFocusedScheme) {
            tagDetails = getTagDetails.isfocused;
        }
        return (React.createElement("div", { className: "d-flex align-item-center gap-2 position-relative" },
            React.createElement("div", { className: "read-more-tooltip align-items-center scheme_name_wrap" },
                React.createElement(GenericSchemeName, { name: keys[1], subText1: keys[9], maxWidth: 100, maxWidthUnit: "%", showTooltip: true, showImage: true, parentClassName: "text-start w-100", tooltipPlacement: "top", tooltipClassName: "scheme-name-tooltip" })),
            isFocusedScheme && (React.createElement("div", { className: "flex-column d-flex align-item-center justify-content-center feature-tag-ap" },
                React.createElement("img", { className: "mgl-5", src: featuredTag, alt: "Featured Scheme" })))));
    };
    var fundColumns = [
        {
            columnName: "",
        },
        {
            columnName: generateTableColumnName("Fund Name", "display_name"),
            key: "",
            key3: "display_name",
            arrows: true,
            columnClassName: "text-end",
            applySorting: true,
            sortKey: "display_name",
            keysForCustomFunction: [
                "schemeId",
                "display_name",
                "isFocused",
                "inceptionDate",
                "tenure",
                "returnsExpectations",
                "benchmark",
                "isfocused",
                "category",
                "isin_code",
            ],
            tdCustomFunction: function (keys) {
                return generateSchemeName(keys, this.keysForCustomFunction);
            },
        },
        {
            columnName: generateTableColumnName("Inception Date", "inception_date"),
            key: "inception_date",
            key3: "inception_date",
            arrows: true,
            columnClassName: "text-end",
            arrowClassName: "justify-content-end",
            applySorting: true,
            tdCustomFunction: function (keys) {
                return (React.createElement("div", { className: "RobotoM_15_400 text-end txt-grey-shade1", style: { cursor: "pointer" } }, keys ? "".concat(moment(keys.toString()).format("DD MMM YYYY")) : "-"));
            },
        },
        {
            columnName: generateTableColumnName("Expected Tenure", "tenure"),
            key: "tenure",
            key3: "tenure",
            key2: "tenure",
            arrows: true,
            columnClassName: "text-end fw-500",
            arrowClassName: "justify-content-end",
            applySorting: true,
            tdCustomFunction: function (keys) {
                var value = keys === null || keys === void 0 ? void 0 : keys.split("(");
                return (React.createElement("div", { className: "RobotoM_15_400 text-end txt-grey-shade1", style: { cursor: "pointer" } },
                    keys ? "".concat(value === null || value === void 0 ? void 0 : value[0]) : "-",
                    React.createElement("br", null),
                    (value === null || value === void 0 ? void 0 : value[1]) && (React.createElement("span", { className: "txt-grey-shade1 DMSanN_14_300 fw-300" }, "(+".concat(value === null || value === void 0 ? void 0 : value[1])))));
            },
        },
        {
            columnName: generateTableColumnName("Return exp.", "returns_expectations"),
            key: "returns_expectations",
            key2: "returns_expectations",
            key3: "returns_expectations",
            arrows: true,
            columnClassName: "text-end fw-500",
            arrowClassName: "justify-content-end",
            applySorting: true,
            tdCustomFunction: function (keys) {
                return (React.createElement("div", { className: "RobotoM_15_400 text-end txt-grey-shade1", style: { cursor: "pointer" } }, keys ? "".concat(keys.toString()) : "-"));
            },
        },
        {
            columnName: generateTableColumnName("Benchmark", "benchmark"),
            key: "benchmark",
            key2: "benchmark",
            key3: "benchmark",
            arrows: true,
            applySorting: true,
            columnClassName: "text-end fw-500",
            arrowClassName: "justify-content-end",
            tdCustomFunction: function (keys) {
                return (React.createElement("div", { className: "RobotoM_15_400 text-end txt-grey-shade1", style: { cursor: "pointer" } }, keys ? "".concat(keys.toString()) : "-"));
            },
        },
        {
            columnName: React.createElement("div", { className: "ms-5" }, "Action"),
            key: "",
            keysForCustomFunction: [
                "schemeId",
                "display_name",
                "isFocused",
                "inceptionDate",
                "tenure",
                "returnsExpectations",
                "benchmark",
                "isfocused",
                "category",
                "min_investment",
                "min_investment_in_cr",
                "category_code",
                "issuer_name",
                "isin_code",
            ],
            tdCustomFunction: function (keysForCustomFunction) {
                return (React.createElement("div", { className: "d-flex align-items-center gap-3 table-row-action-container ms-5" },
                    React.createElement(EdButton, { btnTyp: "tomato-rounded", value: partnerCategory == ILoginTypeEnum.PARTNER
                            ? "Register Lead"
                            : "Place order", slim: true, className: "invest-button text-nowrap DMsanL_15_300", onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                            var element, item;
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                            return __generator(this, function (_o) {
                                switch (_o.label) {
                                    case 0:
                                        element = e.target;
                                        if (element.tagName === "BUTTON") {
                                            e.stopPropagation();
                                        }
                                        if (!(partnerCategory !== ILoginTypeEnum.PARTNER)) return [3 /*break*/, 5];
                                        if (!(ESubProductIds.PMS === String(keysForCustomFunction[11]) &&
                                            firstTimePMS)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, aifPmsDi.global.trxTypeList({
                                                categoryCode: Number(keysForCustomFunction[11]),
                                            })];
                                    case 1:
                                        _o.sent();
                                        setFirstTimePMS(false);
                                        _o.label = 2;
                                    case 2:
                                        if (!(ESubProductIds.AIF === String(keysForCustomFunction[11]) &&
                                            firstTimeAIF)) return [3 /*break*/, 4];
                                        return [4 /*yield*/, aifPmsDi.global.trxTypeList({
                                                categoryCode: Number(keysForCustomFunction[11]),
                                            })];
                                    case 3:
                                        _o.sent();
                                        setFirstTimeAIF(false);
                                        _o.label = 4;
                                    case 4:
                                        item = {
                                            schemeId: Number((_a = keysForCustomFunction[0]) !== null && _a !== void 0 ? _a : ""),
                                            display_name: (_b = keysForCustomFunction[1]) !== null && _b !== void 0 ? _b : "",
                                            isfocused: Boolean((_c = keysForCustomFunction[2]) !== null && _c !== void 0 ? _c : false),
                                            inception_date: (_d = keysForCustomFunction[3]) !== null && _d !== void 0 ? _d : "",
                                            tenure: Number((_e = keysForCustomFunction[4]) !== null && _e !== void 0 ? _e : ""),
                                            returns_expectations: (_f = keysForCustomFunction[5]) !== null && _f !== void 0 ? _f : "",
                                            benchmark: (_g = keysForCustomFunction[6]) !== null && _g !== void 0 ? _g : "",
                                            min_investment: Number(keysForCustomFunction[9]),
                                            min_investment_in_cr: (_h = keysForCustomFunction[10]) !== null && _h !== void 0 ? _h : "",
                                            isin_code: (_j = keysForCustomFunction === null || keysForCustomFunction === void 0 ? void 0 : keysForCustomFunction[13]) !== null && _j !== void 0 ? _j : "",
                                            amc_product_name: (_k = keysForCustomFunction === null || keysForCustomFunction === void 0 ? void 0 : keysForCustomFunction[12]) !== null && _k !== void 0 ? _k : "",
                                            category: (_l = keysForCustomFunction === null || keysForCustomFunction === void 0 ? void 0 : keysForCustomFunction[8]) !== null && _l !== void 0 ? _l : "",
                                        };
                                        props.onClickPlaceOrder(item);
                                        (_m = props.setOpenSB) === null || _m === void 0 ? void 0 : _m.call(props, true);
                                        _o.label = 5;
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); }, hoverType: "tomato-rounded-background", disabled: checked.findIndex(function (x) { return x.schemeId === Number(keysForCustomFunction[0]); }) === -1
                            ? false
                            : true }),
                    React.createElement(EdButtonIcon, { btnIcon: "edel-icon-remove-bookmark", btnTyp: "link", paths: 3, onClick: function (e) {
                            e.stopPropagation();
                            props.deleteBookMark &&
                                props.deleteBookMark([keysForCustomFunction[0]]);
                        }, className: "bg-transparent share-btn txt_dull-grey", disabled: checked.findIndex(function (x) { return x.schemeId === Number(keysForCustomFunction[0]); }) === -1
                            ? false
                            : true })));
            },
        },
    ];
    var rowOnClick = function (element) {
        var _a;
        (_a = props.rowOnClick) === null || _a === void 0 ? void 0 : _a.call(props, element);
        aifPmsDi.aifPms.updateWatchListData(element);
    };
    var shareURL = function (element) {
        var route = (element === null || element === void 0 ? void 0 : element.subCategory) === "Index Fund" ? "index" : "pmsfunds";
        return "".concat(config.baseRoot).concat(config.clientBase, "quotes/").concat(route, "/").concat(element === null || element === void 0 ? void 0 : element.schemeCode);
    };
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (!((_b = (_a = props === null || props === void 0 ? void 0 : props.summaryData) === null || _a === void 0 ? void 0 : _a.returnExpectation) === null || _b === void 0 ? void 0 : _b.conditionValue) &&
            ((_d = (_c = props === null || props === void 0 ? void 0 : props.requestPayload) === null || _c === void 0 ? void 0 : _c.returnExpectation) === null || _d === void 0 ? void 0 : _d.conditionValue)) {
            (_e = props === null || props === void 0 ? void 0 : props.requestPayload) === null || _e === void 0 ? true : delete _e.returnExpectation;
        }
    }, [(_f = (_e = props.summaryData) === null || _e === void 0 ? void 0 : _e.returnExpectation) === null || _f === void 0 ? void 0 : _f.returnExpectation]);
    useEffect(function () {
        var _a, _b, _c, _d;
        var orderByValue = null;
        var orderByDesc = null;
        if (props.requestPayload) {
            orderByValue = props.requestPayload.orderBy || null;
            orderByDesc = !!props.requestPayload.orderByDesc;
        }
        var sortFilter = FilterSortListBookMark.filter(function (item) {
            return (item === null || item === void 0 ? void 0 : item.filterValue) === orderByValue && (item === null || item === void 0 ? void 0 : item.type) === orderByDesc;
        });
        setOrderBy(orderByValue);
        setOrderByDesc(orderByDesc);
        props.setSelectedValue({
            name: (_a = sortFilter === null || sortFilter === void 0 ? void 0 : sortFilter[0]) === null || _a === void 0 ? void 0 : _a.name,
            value: (_b = sortFilter === null || sortFilter === void 0 ? void 0 : sortFilter[0]) === null || _b === void 0 ? void 0 : _b.value,
            type: (_c = sortFilter === null || sortFilter === void 0 ? void 0 : sortFilter[0]) === null || _c === void 0 ? void 0 : _c.type,
            filterValue: (_d = sortFilter === null || sortFilter === void 0 ? void 0 : sortFilter[0]) === null || _d === void 0 ? void 0 : _d.filterValue,
        });
    }, [props.requestPayload]);
    var handleCalculateSchemeNameMaxWidth = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        // TODO: This function needs to be refactored more for more proper functionlity
        try {
            if (((_b = (_a = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _a === void 0 ? void 0 : _a.rows) === null || _b === void 0 ? void 0 : _b.length) && ((_c = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _c === void 0 ? void 0 : _c.rows[0].cells)) {
                var totalOccupiedWidthExceptSchemeColumn_1 = (_e = Array.from((_d = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _d === void 0 ? void 0 : _d.rows[0].cells)) === null || _e === void 0 ? void 0 : _e.reduce(function (sum, cell, index) {
                    if (index !== 1) {
                        return sum + cell.offsetWidth;
                    }
                    return sum;
                }, 0);
                var thead = tableRef.current.querySelector("thead");
                var tbody = tableRef.current.querySelector("tbody");
                if (thead) {
                    var secondTh = thead.querySelectorAll("th")[1]; // 0-based index
                    if (secondTh) {
                        secondTh.style.maxWidth = "".concat(((_g = (_f = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _f === void 0 ? void 0 : _f.parentElement) === null || _g === void 0 ? void 0 : _g.clientWidth) -
                            totalOccupiedWidthExceptSchemeColumn_1 -
                            10, "px");
                    }
                }
                if (tbody) {
                    tbody.querySelectorAll("tr").forEach(function (row) {
                        var _a, _b;
                        var secondTd = row.querySelectorAll("td")[1];
                        if (secondTd) {
                            secondTd.style.maxWidth = "".concat(((_b = (_a = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.clientWidth) -
                                totalOccupiedWidthExceptSchemeColumn_1 -
                                10, "px");
                        }
                    });
                }
            }
        }
        catch (_h) { }
    };
    useEffect(function () {
        handleCalculateSchemeNameMaxWidth();
    }, [props.pmsSchemeList]);
    return (React.createElement(React.Fragment, null,
        (checked === null || checked === void 0 ? void 0 : checked.length) > 0 ? (React.createElement(OfferingsTableCheckboxActions, { selectedDataForComparison: checked, compareButtonCallback: undefined, bookmarkButtonCallback: function () {
                props.savebookMark &&
                    props.savebookMark(checked.map(function (x) { return x.schemeId; }));
            } })) : (React.createElement(React.Fragment, null)),
        props.loader && (React.createElement(GenericTableShimmer, { rowCount: 10, columnCount: 8, columnsWidthClass: "table-shimmer-col-fr2-1-1-1-1-1-1-1_2" })),
        ((_g = props === null || props === void 0 ? void 0 : props.pmsSchemeList) === null || _g === void 0 ? void 0 : _g.length) > 0 && (React.createElement(DynamicPagination, { tableRef: tableRef, dataLengthPerPage: props.dataLengthPerPage || 10, data: props.pmsSchemeList, Bodycomponent: GenericTable, rowOnClick: rowOnClick, rowClassName: function (ele) {
                return checked.findIndex(function (x) { return x.schemeId === ele.schemeId; }) === -1
                    ? ""
                    : "bg_aqua_white";
            }, columns: fundColumns, parentClassName: "top-performing common-compact-table-wrapper ".concat(props.viewAll && "viewAll", " primary-offerings-table-wrapper aif-pms-oof"), infinityScroll: true, manualNext: !props.isAll
                ? false
                : props.viewAll
                    ? props.totalPages > props.page
                    : false, nextFunction: props.viewAll ? props.nextPage : undefined, totalNumberPages: props.viewAll ? props.totalPages : undefined, paginationLoader: props.loader, initPageNumber: props.viewAll ? props.page : undefined, callbackSorted: onSortToggleClick, selectedSortColumnVal: (_h = props === null || props === void 0 ? void 0 : props.requestPayload) === null || _h === void 0 ? void 0 : _h.orderBy, selectedSortVal: ((_j = props === null || props === void 0 ? void 0 : props.requestPayload) === null || _j === void 0 ? void 0 : _j.orderByDesc) ? "DESC" : "ASC", sortIconUp: "edel-icon-arrow-up-thin", sortIconDown: "edel-icon-arrow-down", viewAll: props.viewAll, isPageFromParent: true, sortArrowHighlightingColor: "#6374D4" })),
        showShareModal && (React.createElement(ShareSocialLinks, { setShare: setshowShareModal, value: sharelinks.join("\n") }))));
};
export default TopFundsTableDesk;
